import type { ChangeEvent } from 'react';
import * as S from './SearchInputStyles';

export interface SearchInputProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onClear: () => void;
  className?: string;
  hasIcon?: boolean;
}

const SearchInput = ({ value, placeholder, onChange, onClear, hasIcon = true, className = '' }: SearchInputProps) => (
  <S.Wrapper>
    <S.SearchInput
      type='search'
      value={value}
      placeholder={placeholder}
      onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
      className={`search-input ${className} ${hasIcon ? 'search-icon' : ''}`}
      data-cy='search-input'
    />
    {
      <button
        className='close-icon'
        type='reset'
        onClick={onClear}
      />
    }
  </S.Wrapper>
);
export default SearchInput;
